<div class="card p-5 h-full flex flex-col">
  <div class="flex items-start justify-between gap-2 mb-3">
    <div>
      <p class="text-xs text-secondary font-medium m-0">Expenses this month</p>
      @if (summary().data; as total) {
        <p class="display-4 m-0 leading-tight">
          {{ total.totalMinor | money: total.currencyCode }}
        </p>
      }
    </div>
    <span
      class="flex items-center justify-center w-10 h-10 rounded-full bg-amber-100 text-amber-600 shrink-0">
      <mat-icon svgIcon="mat:receipt_long"></mat-icon>
    </span>
  </div>

  @if (isLoading(summary()) && !summary().data) {
    <div class="flex flex-col gap-2 animate-pulse">
      <div class="h-3 w-24 rounded bg-gray-200 dark:bg-gray-700"></div>
      <div class="h-3 w-full rounded bg-gray-200 dark:bg-gray-700"></div>
      <div class="h-3 w-3/4 rounded bg-gray-200 dark:bg-gray-700"></div>
    </div>
  } @else if (isError(summary())) {
    <div class="flex-1 flex flex-col items-start">
      <p class="text-sm text-secondary m-0 mb-2">
        Couldn't load this month's expenses.
      </p>
      <button mat-button type="button" (click)="retry.emit()">Try again</button>
    </div>
  } @else if (summary().data; as data) {
    @if (data.topCategories.length === 0) {
      <div class="flex-1 flex flex-col justify-center">
        <p class="text-sm text-secondary m-0">
          Nothing recorded this month yet.
        </p>
      </div>
    } @else {
      <div class="flex flex-col gap-2 flex-1">
        @for (category of data.topCategories; track category.categoryId) {
          <div>
            <div class="flex items-baseline justify-between gap-2">
              <span class="text-xs text-default truncate">
                {{ category.name }}
              </span>
              <span class="text-xs font-medium text-default whitespace-nowrap">
                {{ category.amountMinor | money: data.currencyCode }}
              </span>
            </div>
            <div class="h-1.5 rounded-full bg-gray-100 dark:bg-gray-700 mt-1">
              <div
                class="h-1.5 rounded-full bg-amber-500"
                [style.width]="barWidth(data, category.amountMinor)"></div>
            </div>
          </div>
        }
      </div>
    }

    <div class="w-full flex justify-end">
      <a
        class="text-sm text-primary-600 font-medium mt-4 inline-flex items-center gap-1"
        [routerLink]="expensesPath"
        [queryParams]="linkQueryParams()">
        See all expenses
        <mat-icon svgIcon="mat:chevron_right" class="icon-sm"></mat-icon>
      </a>
    </div>
  }
</div>
